import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "adminTrainerList" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "main" }
const _hoisted_4 = { class: "inner d-flex" }
const _hoisted_5 = { class: "contentArea" }
const _hoisted_6 = { class: "profileRow d-flex justify-between" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "mt-2" }
const _hoisted_9 = ["onClick"]

import Sidebar from '../admin/adminSidebar.vue'
import Header from '../admin/adminHeader.vue'
import axios from "@/api/plan";
import { ref, onMounted} from 'vue'
import EditMothsModal from '@/components/admin/updateCalendarModal.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'calenderList',
  setup(__props) {

const calendarList = ref([]);
const selectedCalendar = ref(null)
const showModal = ref(false)

const fetchCalendarList = async () => {
  try {
    const res = await axios.ListCalendar()
    calendarList.value = res.data
    console.log(calendarList.value)
  } catch (err) {
    console.error(err)
  }
}


const editCalendar = (calendarId: number) => {
  const calendar = calendarList.value.find(c => c.month === calendarId)
  if (calendar) {
    selectedCalendar.value = { ...calendar }
    showModal.value = true
  }
}

const closeModal = () => {
  showModal.value = false
  selectedCalendar.value = null
}

onMounted(() => {
   fetchCalendarList()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Header),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(Sidebar),
            _createElementVNode("div", _hoisted_5, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mainTitle d-flex items-center" }, [
                _createElementVNode("h1", null, "달력 백그라운드 관리")
              ], -1)),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendarList.value, (months) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: months.id,
                    class: "profileCard text-center"
                  }, [
                    _createElementVNode("img", {
                      src: months.path,
                      alt: months.month,
                      class: "member-img"
                    }, null, 8, _hoisted_7),
                    _createElementVNode("h5", _hoisted_8, _toDisplayString(months.month) + " 월 ", 1),
                    _createElementVNode("button", {
                      class: "updateBtn mt-1",
                      onClick: ($event: any) => (editCalendar(months.month))
                    }, " 수정 ", 8, _hoisted_9)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    (showModal.value)
      ? (_openBlock(), _createBlock(EditMothsModal, {
          key: 0,
          months: selectedCalendar.value,
          onClose: closeModal,
          onUpdated: fetchCalendarList
        }, null, 8, ["months"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})